import styled from 'styled-components';

export const PoweredOnIndicationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  .powered-on-text {
    color: ${({ theme: { token } }) => token.colorText};
    display: flex;
  }

  .on-off-text {
    text-transform: uppercase;
  }
`;
